import React from 'react';
import ChartContainer from './ChartContainer';
import { useServicesChartsDataContext } from '../../hooks/useServicesChartsDataContext';
import useServicesPerMonthPerYearPercentageChart from './hooks/useServicesPerMonthPerYearPercentageChart';

export const ServicesPerMonthPerYearPercentage = ({ height = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { chartConfig } = useServicesPerMonthPerYearPercentageChart();

    return (
        <ChartContainer
            title={`Evolução ${module.sectionTitle} Mensal no Ano Selecionado (%)`}
            options={chartConfig.options}
            series={chartConfig.series}
            height={350}
        />
    );
};
